
import { toast } from 'react-toastify'
import { TFunction } from 'i18next'
type NotifyPaymentStatusProps = {
    locationSearch: string
    t: TFunction
};

export function NotifyPaymentStatus({ locationSearch, t }: NotifyPaymentStatusProps): void {
    const params = new URLSearchParams(locationSearch);

    if (params.get("status") === "ok") {
        toast.info(t('paymentPage.apartmentPublished'));
        //sessionStorage.setItem('paymentStatusOk', 'true');
    } else if (params.get("status") === "refreshOk") {
        toast.info(t('paymentPopup.messages.refreshDone'));
    } else if (params.get("status") === "generateContractOk") {
        toast.info(t('paymentPopup.messages.generateContractOk'));
  } else if (params.get("status") === "showCreditInfoOk") {
    toast.info(t('paymentPopup.messages.showCreditInfoOk'));
  } else if (params.get("status") === "showBudgetInfoOk") {
    toast.info(t('paymentPopup.messages.showBudgetInfoOk'));
  } else if (params.get("status") === "followUpOk") {
    toast.info(t('paymentPopup.messages.followUpOk'));
  } else if (params.get("status") === "sendForSigningSuccess") {
    toast.info(t('contractCreator.contract.sendForSigningSuccess'));
  } else if (params.get("status") === "verificationOk") {
        try {
            toast.info(t('apartments.messages.verificationOk'));
            const url = new URL(window.location.href);
            url.searchParams.delete('status');
            window.history.replaceState(null, '', url.toString());
        } catch {}
        return;
  } else if (params.get("status") === "fail" || params.get("status") === "error") {
    toast.info(t('paymentPage.paymentFailed'));
  }
}
